// @flow
import classnames from 'classnames';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    '&:after': {
      position: 'absolute',
      overflow: 'hidden',
      display: 'inline-block',
      verticalAlign: 'bottom',
      content: "'\\2026'",
      width: 0,
      WebkitAnimation: '$ellipsis steps(4, end) 1600ms infinite',
      animation: '$ellipsis steps(4, end) 1600ms infinite',
    },
  },
  '@keyframes ellipsis, @-webkit-keyframes-ellipsis': {
    to: {
      width: 28,
    },
  },
}));

interface Props {
  children?: Object;
  className?: string;
}

const LoadingText = ({ children, className }: Props) => {
  const classes = useStyles();

  return <span className={classnames(classes.root, className)}>{children}</span>;
};

export default LoadingText;
